import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import {
    AccordionModule,
    ButtonModule,
    PopoverModule,
    TableModule,
    ToolbarModule
} from '../shared';
import { SharedModule } from '../shared/shared.module';
import { UserSelectorModule } from '../user-selector/user-selector.module';
import { OversignTimeFeatureComponent } from './oversign-time-feature/oversign-time-feature.component';
import { OversignTimePresenterComponent } from './oversign-time-presenter/oversign-time-presenter.component';
import { OversignTimeEffects } from './store/oversign-time.effects';
import * as fromOversign from './store/oversign-time.reducer';

@NgModule({
    declarations: [
        OversignTimePresenterComponent,
        OversignTimeFeatureComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(fromOversign.oversignTimeFeatureKey, fromOversign.reducer),
        EffectsModule.forFeature([OversignTimeEffects]),
        EfaactMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        UserSelectorModule,
        MatRadioModule,
        PopoverModule,
        ToolbarModule,
        ButtonModule,
        AccordionModule,
        TableModule
    ]
})
export class OversignTimeModule {}
